<template>
  <div>
  <van-tabbar>
    <van-tabbar-item icon="home-o" @click="toHome()">首頁</van-tabbar-item>
    <van-tabbar-item icon="photograph" @click="toQr()">掃描QRCode</van-tabbar-item>
    <van-tabbar-item icon="qr-invalid" @click="myCode()">我的QRCode</van-tabbar-item>
  </van-tabbar>

    <div v-show="false">
      <GmapMap
        :center="{lat:0, lng:0}"
        :zoom="17"
        map-type-id="terrain"
        style="width: 0px; height: 0px"
      ></GmapMap>
    </div>

    <b-modal
      ref="my-qr"
      size="sm"
      centered
      @hide="onHide"
      id="modalQr"
      title="我的QR Code"
      hide-header
      hide-footer
    >
      <div class="text-center" id="cheader">
        <b-button @click="closecam()" style="color:#000204;" variant="link">
          <b-icon icon="camera" font-scale="1.5" variant="dark"></b-icon>關閉
        </b-button>
      </div>
      <div class="text-center" id="cbodyer">
        <qrcode-stream
          :key="qrcodeKey"
          :camera="camera"
          :track="paintOutline"
          @init="onInit"
          v-if="!destroyed"
          @decode="onDecode"
        >
        </qrcode-stream>
      </div>
    </b-modal>
    <van-popup 
      v-model="showQrPopup" 
      closeable
      position="top"
      :close-on-click-overlay="false"
      :style="{ width: '100%',  padding: '20px', background: '#ffffff', borderRadius: '0 0 16px 16px' }"
    >
      <div class="text-center" id="cbodyer">
        <div v-if="!list" @click="toclose()" style="cursor: pointer;">
          <div class="qrbody">
            <vue-qr
              ref="qrCode"
              :text="textValue"
              :logoScale="40"
              :margin="10"
              :size="320"
            />
            <!-- 其餘內容不變 -->
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
//import router from '../../router'
import { mapState, mapMutations } from "vuex";
//import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from 'vue-qrcode-reader'
import * as moment from "moment/moment";
import { QrcodeStream } from "vue-qrcode-reader";
import { joinService, macService } from "../../_services";
import { gmapApi } from "vue2-google-maps";
import VueQr from "vue-qr";
import logoImg from "@/assets/lineicon.svg";

const postData = params => {
  return joinService.signin(params);
};

const postApply = params => {
  return joinService.postApply(params);
};

const queryus = id => {
  return macService.macfind(id);
};

export default {
  name: "Acbottommenu",
  components: {
    QrcodeStream,
    VueQr, 
  },
  props: {
    obj: Object
  },
  data() {
    return {
      xurl: "",
      imgs: {
        width: 0,
        height: 0
      },
      qrcodeKey: 0,
      loading: false,
      destroyed: false,
      camera: "auto",
      list: true,
      showScanConfirmation: false,
      gettingLocation: false,
      logoPath: logoImg,
      textValue: "",
      errorStr: null,
      currentTime: moment(),
      displayname: "",      
      iconLoading2: false, 
      showQrPopup: false,     
    };
  },
  computed: {
    ...mapState("account", ["user"]),
    ...mapState("sing", ["singrecords"]),
    google: gmapApi
  },
  mounted() {
    this.singini();
  },

  methods: {
    ...mapMutations("sing", ["singini", "singadd", "singremov"]),
    catImg(imgs) {
      return require(`../../assets/${imgs}`);
    },

    async onInit(promise) {
      this.loading = true;
      try {
        await promise;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
        this.showScanConfirmation = this.camera === "off";
      }
    },

    async myCode() {
      this.list = false;
      this.textValue = "actjoin:" + this.user.data.user.id;
      this.displayname = this.user.data.user.display_name;
      this.showQrPopup = true;  // 新代碼
    },

    toclose() {
      this.list = true;
      this.showQrPopup = false;
    },

    async reload() {
      this.destroyed = true;

      await this.$nextTick();

      this.destroyed = false;
    },

    covert(type, val) {
      if (type == "theme") {
        let rs = this.mytheme.filter(el => {
          return el.value === val;
        });
        return rs[0].title;
      }
    },

    toGo() {
      //this.$emit("savelove","love")
      //this.user.data.user.id
    },
    toHome(){
      this.$emit("savelove","home")
      //this.user.data.user.id
    },     

    toGoact() {
      //this.$emit("savelove","act")
    },

    toQr() {
      this.qrcodeKey++;
      this.unpause();
      this.reload();
      this.$refs["my-qr"].show();
    },
    closecam() {
      this.$refs["my-qr"].hide();
    },

    async onDecode(decodedString) {
      this.pause();
      let rs = this.validation(decodedString); //驗證報到時間
      if (rs !== ""  && rs !== "finish" && rs !== "apply") {
        let ch1 = this.singrecords.find(element => element == rs.fid);
        //console.log('1.',ch1,rs.fid)
        if (this.singrecords.length == 0 || ch1 == undefined) {
          let tman = await this.getUs(rs)
            .then(val => {
              return val;
            })
            .catch(val => {
              return val;
            });
          if (tman === "data") {
            await this.toScan(rs) //報到一
              .then(val => {
                return val;
              })
              .catch(val => {
                return val;
              })
              .finally(() => {
                console.log("done");
              });
            this.singadd(rs.fid);
          } else {
            this.$emit("scanCode", { code: "304" }); //報到失敗
          }
                     
        } else {
          this.$emit("scanCode", { code: "300" }); //已報到過
        }
      } else if(rs === "apply"){
        decodedString = decodedString.replace("actjoin:","")           
        let strAry = decodedString.split(",");        
        let rs = {
              id: parseInt(strAry[3]),
              sdate: strAry[1],
              edate: strAry[2],
              fid: parseInt(strAry[0]),
              uid:this.user.data.user.id,
              sid: parseInt(strAry[4]),
              limits: parseInt(strAry[5])
            };
        await this.toApply(rs) //報到二
            .then(val => {
              return val;
            })
            .catch(val => {
              return val;
            });
      } else {
        let code = "400";
        rs == "notYet" ? (code = "401") : (code = "400");
        rs == "finish" ? (code = "402") : (code = "400");
        this.$emit("scanCode", { code: code });
      }

      await this.timeout(1400);
      //this.unpause();
      this.closeCal()
    },

    closeCal() {
      this.destroyed = true;
      this.$refs["my-qr"].hide();
    },    

    unpause() {
      this.camera = "auto";
    },

    pause() {
      this.camera = "off";
    },

    timeout(ms) {
      return new Promise(resolve => {
        window.setTimeout(resolve, ms);
      });
    },

    toScan(val) { //報到
      return new Promise((resolve, reject) => {
        let now = moment();
        let tmp = { msg: "done", code: 300, data: {} };

        var dateTimeString = val.sdate; //提早一小時
        var parsedMoment = moment(dateTimeString, "YYYY-MM-DD HH:mm");
        var oneHourBefore = parsedMoment.subtract(1, 'hours');
        var myDates = oneHourBefore.format('YYYY-MM-DD HH:mm');

        var dateTimeString2 = val.edate; //晚一小時
        var parsedMoment2 = moment(dateTimeString2, "YYYY-MM-DD HH:mm");
        var oneHourAfter = parsedMoment2.add(1, 'hours');
        var myDates2 = oneHourAfter.format('YYYY-MM-DD HH:mm');

        if (
          myDates <=
          now.format("YYYY-MM-DD HH:mm") &&
          myDates2 >
            now.format("YYYY-MM-DD HH:mm")
        ) {
          //let tmp = {check:true, code:200,data:[]}
          val.sdate = moment(val.sdate).format("YYYY-MM-DD HH:mm");
          val.edate = moment(val.edate).format("YYYY-MM-DD HH:mm");
          postData({
            ...val
          }).then(({ data }) => {

            this.$emit("scanCode", {code:data.data.code,data:data.data});
            if (data.data.code == 200) {
              //this.$emit("scanCode", data);
              resolve(data);
            } else {
              reject(tmp);
            }
          });
        } else {
          reject(tmp);
        }
      });
    },

    validation(val) {
      let tmp = "";
      if (val !== "") {
        if (val.substring(0, 7) === "actjoin") {
          val = val.replace("actjoin:","")           
          let strAry = val.split(",");
          if (strAry.length == 6) {
            let obj = {
              id: parseInt(strAry[3]),
              sdate: strAry[1],
              edate: strAry[2],
              fid: parseInt(strAry[0]),
              uid: this.user.data.user.id,
              sid: parseInt(strAry[4]),
              limits: parseInt(strAry[5])
            };
            tmp = obj;  
            // 提早一小時
            var dateTimeString = strAry[1];
            var parsedMoment = moment(dateTimeString, "YYYY-MM-DD HH:mm");
            var oneHourBefore = parsedMoment.subtract(1, 'hours');
            var myDates = oneHourBefore.format('YYYY-MM-DD HH:mm');
            // 晚一小時
            var dateTimeString2 = strAry[2];
            var parsedMoment2 = moment(dateTimeString2, "YYYY-MM-DD HH:mm");
            var oneHourAfter = parsedMoment2.add(1, 'hours');
            var myDates2 = oneHourAfter.format('YYYY-MM-DD HH:mm');
            if (
              !( //目前到時間大於提早一小時 and 結束時間大於目前的時間
                myDates <
                  this.fdateformat(this.currentTime) &&
                  myDates2 > this.fdateformat(this.currentTime)
              )
            ) {
              tmp = "";
            }
            if (  // 活動開始時間 > 現在時間 = 活動還沒開始
              myDates > this.fdateformat(this.currentTime)
            ) {
              tmp = "apply";
            }
            if ( //目前的時間大於結束時間
              myDates2 < this.fdateformat(this.currentTime)
            ) {
              tmp = "finish";
            }  
            //console.log(tmp,myDates,this.fdateformat(this.currentTime))        
          }
        }
      }
      return tmp;
    },

    fdateformat(val) {
      return moment(val).format("YYYY-MM-DD HH:mm");
    },

    paintOutline(detectedCodes, ctx) {
      for (const detectedCode of detectedCodes) {
        const [firstPoint, ...otherPoints] = detectedCode.cornerPoints;

        ctx.strokeStyle = "red";
        ctx.lineWidth = 4;

        ctx.beginPath();
        ctx.moveTo(firstPoint.x, firstPoint.y);
        for (const { x, y } of otherPoints) {
          ctx.lineTo(x, y);
        }
        ctx.lineTo(firstPoint.x, firstPoint.y);
        ctx.closePath();
        ctx.stroke();
      }
    },

    onHide(evt) {
      if (evt.trigger === "backdrop") {
        evt.preventDefault();
      }
    },

    async getLocation() {
      return new Promise((resolve, reject) => {
        if (!("geolocation" in navigator)) {
          reject(new Error("Geolocation is not available."));
        }
        navigator.geolocation.getCurrentPosition(
          pos => {
            resolve(pos);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    async locateMe() {
      this.gettingLocation = true;
      try {
        this.gettingLocation = false;
        let locals = await this.getLocation();
        let val = await this.getgeocode(locals);
        this.$emit("toLocal", val);
      } catch (e) {
        this.gettingLocation = false;
        this.errorStr = e.message;
      }
    },

    //console.log('latitude:', val.coords.latitude,"longitude:",val.coords.longitude);
    async getgeocode(locals) {
      //console.log("latitude:",locals.coords.latitude,"longitude:",locals.coords.longitude)
      return new Promise(resolve => {
        var geocoder = new this.google.maps.Geocoder();
        geocoder.geocode(
          {
            location: {
              lat: locals.coords.latitude,
              lng: locals.coords.longitude
            }
          },
          (results, status) => {
            if (status === "OK") {
              //console.log("formatted_address:",results[0])
              resolve(results[0].formatted_address);
            }
          }
        );
      });
    },
    getUs(val) {
      return new Promise((resolve, reject) => {
        let now = moment();       
        let tmp = null;
        var dateTimeString = val.sdate;
        var parsedMoment = moment(dateTimeString, "YYYY-MM-DD HH:mm");
        var oneHourBefore = parsedMoment.subtract(1, 'hours');
        var myDates = oneHourBefore.format('YYYY-MM-DD HH:mm');

        // 晚一小時
        var dateTimeString2 = val.edate;
        var parsedMoment2 = moment(dateTimeString2, "YYYY-MM-DD HH:mm");
        var oneHourAfter = parsedMoment2.add(1, 'hours');
        var myDates2 = oneHourAfter.format('YYYY-MM-DD HH:mm');        

        if (
          myDates <=
          now.format("YYYY-MM-DD HH:mm") &&
          myDates2 >
            now.format("YYYY-MM-DD HH:mm")
        ) {
          queryus(val.fid).then(({ data }) => {
            if (data.states !== "" && data.states === "Y" ) {
              tmp = "data";
              resolve(tmp);
            } else {
              reject(tmp);
            }
          });
        } else {
          reject(tmp);
        }
      });
    },

    toApply(val){
      return new Promise((resolve, reject) => {
        var currentMoment = moment();
        var dateTimeString = val.sdate;
        var parsedMoment = moment(dateTimeString, "YYYY-MM-DD HH:mm");
        var oneHourBefore = parsedMoment.subtract(1, 'hours');
        var myDates = oneHourBefore.format('YYYY-MM-DD HH:mm');        
        let tmp = null;
        if (
          myDates >
          currentMoment.format("YYYY-MM-DD HH:mm")
        ) {
          postApply(val).then(({ data }) => {
            this.$emit("scanCode", {code:data.data.code});
            if (data.data.code == 209 ) {
              tmp = "data";
              resolve(tmp);
            } else {
              reject(tmp);
            }
          });
        } else {
          reject(tmp);
        }
      });
    },    


  }
};
</script>
<style scoped>

.imgs {
  margin: 25%;
  width: 60px;
  height: 60px;
}
#cheader {
  margin: 0px auto;
  padding: 0px;
  background-color: #ffffff;
  width: 50%;
  border-top-left-radius: 10.5rem;
  border-top-right-radius: 10.5rem;
}
#cbodyer {
  padding: 10px;
  background-color: #ffffff;
}
/* 為 van-popup 添加樣式 */
:deep(.van-popup) {
  border-radius: 10px;
  overflow: hidden;
}

/* 使 cbodyer 在 van-popup 中正確顯示 */
#cbodyer {
  padding: 10px;
  background-color: #ffffff;
}
</style>
<style>
#modalQr > .modal-dialog > .modal-content > .modal-body {
  border-color: transparent;
  background-color: transparent !important;
  color: white;
}
#modalQr > .modal-dialog > .modal-content {
  border-color: transparent;
  background-color: transparent !important;
}
:deep(.van-popup) {
  border-radius: 0 !important;
}
</style>

